import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import CalculateDueDate from './CalculateDueDate/index';
import ShowResult from './ShowResults/index';
import { CalculatorBox, CalculatorImage } from './styled';

export default function CalculateDueDateComponent() {
  const [dueDate, setDueDate] = useState(null);
  const toolImage = images.mylocalendar;
  const { query } = useRouter();
  const router = useRouter();
  useEffect(() => {
    if (query.result == 'true' && !dueDate) {
      const search = new URLSearchParams(window.location.search);
      search.delete('result');
      let params = '';
      if (search.toString() != '') {
        params = '?' + search.toString();
      }
      router.replace(router.route + params, '', {
        shallow: true,
      });
    }
  }, [query]);

  return (
    <CalculatorBox>
      <div className="centerImage">
        <CalculatorImage
          src={toolImage}
          srcSet={`${toolImage}?tr=w-210,q-80 2w, ${toolImage}?tr=w-260,q-80 608w`}
          sizes="(max-width: 720px) 2px,608px"
          alt=""
        />
      </div>
      {dueDate && query.result == 'true' ? (
        <ShowResult dueDate={dueDate} setDueDate={setDueDate} />
      ) : (
        <CalculateDueDate setDueDate={setDueDate} />
      )}
    </CalculatorBox>
  );
}
